import { cn } from '@/utils/cn';
import { AlertCircle, CheckCircle, Info, XCircle } from 'lucide-react';

type AlertVariant = 'info' | 'success' | 'warning' | 'error';

interface AlertProps {
  variant?:  AlertVariant;
  title?:    string;
  message:   string;
  className?: string;
}

const config: Record<AlertVariant, { icon: React.ReactNode; classes: string }> = {
  info: {
    icon:    <Info className="h-4 w-4 shrink-0" />,
    classes: 'bg-blue-50 text-blue-800 border-blue-200',
  },
  success: {
    icon:    <CheckCircle className="h-4 w-4 shrink-0" />,
    classes: 'bg-emerald-50 text-emerald-800 border-emerald-200',
  },
  warning: {
    icon:    <AlertCircle className="h-4 w-4 shrink-0" />,
    classes: 'bg-amber-50 text-amber-800 border-amber-200',
  },
  error: {
    icon:    <XCircle className="h-4 w-4 shrink-0" />,
    classes: 'bg-red-50 text-red-800 border-red-200',
  },
};

export default function Alert({ variant = 'info', title, message, className }: AlertProps) {
  const { icon, classes } = config[variant];
  return (
    <div className={cn('flex gap-3 rounded-lg border p-3 text-sm', classes, className)}>
      <span className="mt-0.5">{icon}</span>
      <div>
        {title && <p className="font-medium mb-0.5">{title}</p>}
        <p className="leading-relaxed">{message}</p>
      </div>
    </div>
  );
}
